// Native Base Default Theme 헬퍼

// =================================================================================================
// 가져오기
// =================================================================================================
// 고정 영역

// 동적 영역

// =================================================================================================
// 상수
// =================================================================================================
// NativeBase Default Theme [The theme object is where you define your application's color palette, type scale, font stacks, breakpoints, border radius values, and more.]
const nativeBaseDefaultTheme = {
  // Colors [You can add a theme.colors object to provide colors for your project. By default these colors can be referenced by the color, borderColor, backgroundColor, etc.. props. You can also add .alpha:{number} to add levels of opacity to a colour. The number can also be added in the theme file. Ex: red.300:alpha.30, You can read more about this in  opacity section]
  colors: {
    //  primary = cyan
    primary50: 'primary.50', // #ecfeff [흰 파스텔파란색] [name + Design token]
    primary100: 'primary.100', // #cffafe
    primary200: 'primary.200', // #a5f3fc
    primary300: 'primary.300', // #67e8f9
    primary400: 'primary.400', // #22d3ee
    primary500: 'primary.500', // #06b6d4 [파스텔파란색]
    primary600: 'primary.600', // #0891b2
    primary700: 'primary.700', // #0e7490
    primary800: 'primary.800', // #155e75
    primary900: 'primary.900', // #164e63 [흑 파스텔파란색]

    //  secondary = pink
    secondary50: 'secondary.50', // #fdf2f8 [흰 파스텔핑크]
    secondary100: 'secondary.100', // #fce7f3
    secondary200: 'secondary.200', // #fbcfe8
    secondary300: 'secondary.300', // #f9a8d4
    secondary400: 'secondary.400', // #f472b6
    secondary500: 'secondary.500', // #ec4899 [파스텔핑크]
    secondary600: 'secondary.600', // #db2777
    secondary700: 'secondary.700', // #be185d
    secondary800: 'secondary.800', // #9d174d
    secondary900: 'secondary.900', // #831843 [흑 파스텔핑크]

    //  tertiary
    tertiary50: 'tertiary.50', // # [흰 파스텔녹색]
    tertiary100: 'tertiary.100', // #
    tertiary200: 'tertiary.200', // #
    tertiary300: 'tertiary.300', // #
    tertiary400: 'tertiary.400', // #
    tertiary500: 'tertiary.500', // # [파스텔녹색]
    tertiary600: 'tertiary.600', // #
    tertiary700: 'tertiary.700', // #
    tertiary800: 'tertiary.800', // #
    tertiary900: 'tertiary.900', // # [흑 파스텔녹색]

    //  danger
    danger50: 'danger.50', // # [흰 진핑크]
    danger100: 'danger.100', // #
    danger200: 'danger.200', // #
    danger300: 'danger.300', // #
    danger400: 'danger.400', // #
    danger500: 'danger.500', // # [진핑크]
    danger600: 'danger.600', // #
    danger700: 'danger.700', // #
    danger800: 'danger.800', // #
    danger900: 'danger.900', // # [흑 진핑크]

    //  error
    error50: 'error.50', // # [흰 진주황]
    error100: 'error.100', // #
    error200: 'error.200', // #
    error300: 'error.300', // #
    error400: 'error.400', // #
    error500: 'error.500', // # [진주황]
    error600: 'error.600', // #
    error700: 'error.700', // #
    error800: 'error.800', // #
    error900: 'error.900', // # [흑 진주황]

    //  success
    success50: 'success.50', // # [흰 초록]
    success100: 'success.100', // #
    success200: 'success.200', // #
    success300: 'success.300', // #
    success400: 'success.400', // #
    success500: 'success.500', // # [초록]
    success600: 'success.600', // #
    success700: 'success.700', // #
    success800: 'success.800', // #
    success900: 'success.900', // # [흑 초록]

    //  warning
    warning50: 'warning.50', // # [흰 주황]
    warning100: 'warning.100', // #
    warning200: 'warning.200', // #
    warning300: 'warning.300', // #
    warning400: 'warning.400', // #
    warning500: 'warning.500', // # [주황]
    warning600: 'warning.600', // #
    warning700: 'warning.700', // #
    warning800: 'warning.800', // #
    warning900: 'warning.900', // # [흑 주황]

    //  muted

    //  info

    //  light

    //  singletons

    //  rose

    //  pink
    pink50: 'pink.50', // # [흰 파스텔핑크]
    pink100: 'pink.100', // #
    pink200: 'pink.200', // #
    pink300: 'pink.300', // #
    pink400: 'pink.400', // #
    pink500: 'pink.500', // # [파스텔핑크]
    pink600: 'pink.600', // #
    pink700: 'pink.700', // #
    pink800: 'pink.800', // #
    pink900: 'pink.900', // # [흑 파스텔핑크]

    //  fuchsia

    //  purple

    //  violet

    //  indigo

    //  blue

    //  lightBlue

    //  darkBlue

    //  cyan

    //  teal

    //  emerald

    //  green

    //  lime

    //  yellow

    //  amber

    //  orange

    //  amber

    //  red

    //  warmGray

    //  trueGray

    //  gray

    //  coolGray

    //  blueGray

    //  dark
  },

  // Typography
  //  fonts
  fonts: {
    heading: undefined,
    body: undefined,
    mono: undefined,
  },

  //  fontSizes
  fontSizes: {
    '2xs': 10,
    xs: 12,
    sm: 14,
    md: 16,
    lg: 18,
    xl: 20,
    '2xl': 24,
    '3xl': 30,
    '4xl': 36,
    '5xl': 48,
    '6xl': 60,
    '7xl': 72,
    '8xl': 96,
    '9xl': 128,
  },

  //  fontWeights
  fontWeights: {
    hairline: 100,
    thin: 200,
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
    black: 900,
    extrablack: 950,
  },

  //  lineHeights
  lineHeights: {
    '2xs': '1em',
    xs: '1.125em',
    sm: '1.25em',
    md: '1.375em',
    lg: '1.5em',
    xl: '1.75em',
    '2xl': '2em',
    '3xl': '2.5em',
    '4xl': '3em',
    '5xl': '4em',
  },

  //  letterSpacings
  letterSpacings: {
    xs: '-0.05em',
    sm: '-0.025em',
    md: 0,
    lg: '0.025em',
    xl: '0.05em',
    '2xl': '0.1em',
  },

  // 크기 (단위: 밀도독립화소=DIP=DP=모든장치에서 동일 크기로 보임) ResponsiveValue<number | "px" | "0" | "full" | "sm" | "6" | "2xs" | "8" | "xs" | "12" | "md" | "16" | "xl" | "24" | "32" | "2" | "0.5" | "4" | "3" | "lg" | "1" | "2xl" | "10" | "20" | "64" | "container" | ... 28 more ... | (string & {})>
  size: {
    0: 0, // 0px
    1: 1, // 4px
    2: 2, // 8px
    3: 3, // 12px
    4: 4, // 16px
    5: 5, // 20px
    6: 6, // 24px
    7: 7, // 28px
    8: 8, // 32px
    9: 9, // 36px
    10: 10, // 40px
    12: 12, // 48px
    16: 16, // 64px
    20: 20, // 80px
    24: 24, // 96px
    32: 32, // 128px
    40: 40, // 160px
    48: 48, // 192px
    56: 56, // 224px
    64: 64, // 256px
    72: 72, // 288px
    80: 80, // 320px
    96: 96, // 384px
    px: 'px', // 1px
    0.5: 0.5, // 2px
    1.5: 1.5, // 6px
    2.5: 1.5, // 10px
    3.5: 3.5, // 14px
    '1per2': 1 / 2, // 50%
    '1per3': 1 / 3, // 33.333%
    '2per3': 2 / 3, // 66.666%
    '1per4': '25%', // 25%
    '2per4': '50%', // 50%
    '3per4': '75%', // 75%
    '1per5': '20%', // 20%
    '2per5': '40%', // 40%
    '3per5': '60%', // 60%
    '4per5': '80%', // 80%
    '1per6': '16.666%', // 16.666%
    '2per6': '33.333%', // 33.333%
    '3per6': '50%', // 50%
    '4per6': '66.666%', // 66.666%
    '5per6': '83.333%', // 83.333%
    full: 'full', // 100% [풀 이지만, 이미지는 원본사이즈보다 영역이 작아지면, 잘림. 영역 큰 축 기준으로 원본 비율 안깨뜨리고 크기 조정됨.]
  },

  // 투명도 [The opacity key is used in opacity style object and to define colors opacity using the red-green-blue-alpha (RGBA) model, RGBA color values are an extension of RGB color values with an alpha channel - which specifies the opacity of the color.]
  opacity: {
    0: 0, // [투명]
    5: 0.05,
    10: 0.1,
    20: 0.2,
    25: 0.25,
    30: 0.3,
    40: 0.4,
    50: 0.5,
    60: 0.6,
    70: 0.7,
    75: 0.75,
    80: 0.8,
    90: 0.9,
    95: 0.95,
    100: 1, // [불투명]
  },

  // 그림자 [The shadow key allows you to customize the global box shadow for your project.]
  shadows: {
    0: 0, // [작다]
    // {
    //   shadowColor: '#000',
    //   shadowOffset: {
    //     width: 0,
    //     height: 1,
    //   },
    //   shadowOpacity: 0.18,
    //   shadowRadius: 1.0,
    //   elevation: 1,
    // }
    1: 1,
    // {
    //   shadowColor: '#000',
    //   shadowOffset: {
    //     width: 0,
    //     height: 1,
    //   },
    //   shadowOpacity: 0.2,
    //   shadowRadius: 1.41,
    //   elevation: 2,
    // }
    2: 2,
    // {
    //   shadowColor: '#000',
    //   shadowOffset: {
    //     width: 0,
    //     height: 1,
    //   },
    //   shadowOpacity: 0.22,
    //   shadowRadius: 2.22,
    //   elevation: 3,
    // }
    3: 3,
    // {
    //   shadowColor: '#000',
    //   shadowOffset: {
    //     width: 0,
    //     height: 2,
    //   },
    //   shadowOpacity: 0.23,
    //   shadowRadius: 2.62,
    //   elevation: 4,
    // }
    4: 4,
    // {
    //   shadowColor: '#000',
    //   shadowOffset: {
    //     width: 0,
    //     height: 2,
    //   },
    //   shadowOpacity: 0.25,
    //   shadowRadius: 3.84,
    //   elevation: 5,
    // }
    5: 5,
    // {
    //   shadowColor: '#000',
    //   shadowOffset: {
    //     width: 0,
    //     height: 3,
    //   },
    //   shadowOpacity: 0.27,
    //   shadowRadius: 4.65,
    //   elevation: 6,
    // }
    6: 6,
    // {
    //   shadowColor: '#000',
    //   shadowOffset: {
    //     width: 0,
    //     height: 3,
    //   },
    //   shadowOpacity: 0.29,
    //   shadowRadius: 4.65,
    //   elevation: 7,
    // }
    7: 7,
    // {
    //   shadowColor: '#000',
    //   shadowOffset: {
    //     width: 0,
    //     height: 4,
    //   },
    //   shadowOpacity: 0.3,
    //   shadowRadius: 4.65,
    //   elevation: 8,
    // }
    8: 8,
    // {
    //   shadowColor: '#000',
    //   shadowOffset: {
    //     width: 0,
    //     height: 4,
    //   },
    //   shadowOpacity: 0.32,
    //   shadowRadius: 5.46,
    //   elevation: 9,
    // }
    9: 9, // [크다]
    // {
    //   shadowColor: '#000',
    //   shadowOffset: {
    //     width: 0,
    //     height: 5,
    //   },
    //   shadowOpacity: 0.34,
    //   shadowRadius: 6.27,
    //   elevation: 10,
    // }
  },
};

// =================================================================================================
// 내보내기
// =================================================================================================
export default nativeBaseDefaultTheme;
